import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

export interface AgBadgeInfo {
  readonly text: string;
  readonly color?: string;
}

export interface AgBadgeRendererParams<TValue = any> extends ICellRendererParams<any, TValue> {
  getBadgeInfo: (value: TValue) => AgBadgeInfo;
}

const BADGE_COLOR_CLASSES = new Map<string, string>([
  ['blue', 'blue'],
  ['lightBlue', 'light-blue'],
  ['darkBlue', 'dark-blue'],
  ['lightestBlue', 'lightest-blue'],
  ['purple', 'purple'],
  ['success', 'success'],
  ['offline', 'offline'],
  ['information', 'information'],
  ['pending', 'pending'],
  ['warning', 'warning'],
  ['outline', 'outline'],
  ['darkGray', 'dark-gray'],
  ['lightGray', 'light-gray'],
  ['grayOutline', 'gray-outline'],
]);

@Component({
  selector: 'app-ag-badge-render',
  templateUrl: './ag-badge-render.component.html',
  styleUrls: ['./ag-badge-render.component.scss'],
  imports: [NgClass],
  standalone: true,
})
export class AgBadgeRenderComponent implements ICellRendererAngularComp {
  params: any;

  badgeText: string = '';
  badgeColorCssClass: string = '';
  showBadge: boolean = false;

  agInit(params: any): void {
    this.params = params;
    this.getBadgeInfo();
  }

  refresh(): boolean {
    return false;
  }

  private getBadgeInfo(): void {
    const badgeInfo = this.params.getBadgeInfo(this.params.value);

    this.showBadge = !!badgeInfo.color;
    this.badgeColorCssClass = badgeInfo.color ? this.getBadgeColor(badgeInfo.color) : '';
    this.badgeText = badgeInfo.text;
  }

  private getBadgeColor(color: string): string {
    return `ft-badge-${BADGE_COLOR_CLASSES.get(color) ?? 'blue'}`;
  }
}
